module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_2000-Grey-dbc532609039632aad23026f7c6c363f.png";